import lodash from 'lodash'
import moment from 'moment'
import * as react from 'react'
import { hashHistory } from 'react-router'
import * as superagent from 'superagent'
import type { Hive } from '../../src/modules/hive'
import { globalReduxStore } from '../../src/modules/initStore'
import * as sentry from '../../src/utils/sentry'
import type { Base_Bus } from '../Base/Base.Bus'
import { DS_getData, DS_setData } from '../DS/DS.Data'
import { Sett_loadDataDump } from '../Sett/Sett.loadDataDump'
import { Sync_reset, Sync_stop, Sync_sync } from '../Sync/Sync.initialise'
import { setTodoDeletionThreshold } from '../Todo/Todo.initialise'
import { Util_exposeGlobally } from '../Util/Util.window'

// These rely on the hive having been initialized
export function Evnt_addHiveToWindow(hive: Hive, bus: Base_Bus) {
    Util_exposeGlobally({
        store: globalReduxStore,
        Sync_stop,
        Sync_sync: (label: string = 'Manual sync') => Sync_sync(label, bus),
        Sync_reset: () => Sync_reset(bus),
        HIVE: hive,
    })
}

// These can be added without initialization
export function Evnt_addModulesToWindow() {
    Util_exposeGlobally({
        lodash,
        moment,
        react,
        superagent,
        hashHistory,
        sentry,
        DS_getData,
        DS_setData,
        loadDataDump: Sett_loadDataDump,
        setTodoDeletionThreshold,
    })
}
